import React from "react";

function getDisplayValue(question, value) {
  if (value === undefined || value === null || value === "") return "-";
  if (Array.isArray(value)) {
    if (value.length === 0) return "-";
    const optionMap = new Map((question.options || []).map((item) => [item.value, item.label]));
    return value.map((item) => optionMap.get(item) || String(item)).join(", ");
  }
  const option = question.options?.find((item) => item.value === value);
  if (option?.label) return option.label;
  if (question.type === "range") {
    return `₹${new Intl.NumberFormat("en-IN").format(value)}`;
  }
  return String(value);
}

function isFilledAnswer(value) {
  if (value === undefined || value === null) return false;
  if (Array.isArray(value)) return value.length > 0;
  return String(value).trim() !== "";
}

function ReviewScreen({ selectedCategory, questions, answers, onBack, onSubmit }) {
  const answeredQuestions = questions
    .map((question) => ({
      id: question.id,
      questionText: question.prompt || question.label || "Question",
      answerText: getDisplayValue(question, answers[question.id]),
      rawValue: answers[question.id],
    }))
    .filter((item) => isFilledAnswer(item.rawValue));

  return (
    <div className="req-screen req-screen-review">
      <div className="req-content">
        <div className="req-inline-header">
          <button
            type="button"
            className="req-back-icon-btn"
            onClick={onBack}
            aria-label="Go back"
          >
            <img src="/caretLeft.svg" alt="" />
          </button>
          <p className="req-eyebrow">Post your requirement</p>
        </div>

        <h1 className="req-review-title">Requirement overview</h1>

        <div className="req-review-group">
          <h3>Service Required</h3>
          <p>{selectedCategory?.label || "-"}</p>
        </div>

        {answeredQuestions.length > 0 ? (
          <div className="req-review-service-list">
            {answeredQuestions.map((item) => (
              <div key={item.id} className="req-review-service-item">
                <h4>{item.questionText}</h4>
                <p>{item.answerText}</p>
              </div>
            ))}
          </div>
        ) : (
          <div className="req-review-group">
            <h3>Responses</h3>
            <p className="req-review-details-text">No answers filled yet.</p>
          </div>
        )}
      </div>

      <div className="req-footer">
        <div className="req-footer-actions req-footer-actions-select">
          <button type="button" className="req-secondary-btn" onClick={onBack}>
            Go back
          </button>
          <button
            type="button"
            className="req-primary-btn"
            data-analytics-lead-submit
            onClick={onSubmit}
          >
            Publish requirement
          </button>
        </div>
      </div>
    </div>
  );
}

export default ReviewScreen;
